export default "__VITE_ASSET__PCeVXPv8__"